<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8u8Hl1/tc-custom/9781400206476.jpg?1728851662434" alt="This image is the cover for the book Say Goodbye to Survival Mode"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Say Goodbye to Survival Mode
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Calling the super busy, the stressed out, the overtired.</b></p><p>You know you're made for a more fulfilling life. With this book, you’ll know where to start.</p><p>You wake up tired. Your to-do list is too long. The commitments—and the laundry—are piling up, but your energy keeps dwindling. You feel like you're simply making it through the days, not living or enjoying any part of them.</p><p>In <i>Say Goodbye to Survival Mode</i>, you'll find both practical ideas and big-picture perspective that will inspire you to live life on purpose. As a wife, mother of three, and founder of the wildly successful blog MoneySavingMom.com, Crystal Paine has walked the road from barely surviving to living with intention. With the warmth and candor of a dear friend, she shares what she's learned along the way, helping you:</p>feel healthier and more energetic by setting priorities and boundarieseliminate stress with savvy management of your time, money, and homeget more done by setting realistic goals and embracing disciplinerediscover your passions—and the confidence to pursue them <p>Packed with straightforward solutions you'll use today and inspirational stories you'll remember for years, <i>Say Goodbye to Survival Mode</i> is a must for any woman who's ever longed for the freedom to enjoy life, not just survive it.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Crystal Paine
      </h2>
      
      <p class="authorDescription body article"><P>Crystal Paine is a speaker and author of the <I>New York Times</I> bestseller <I>Say Goodbye to Survival Mode</I>. In 2007, she founded MoneySavingMom.com, a site that has since grown to become one of the most popular blogs on the web, currently averaging close to 1.2 million readers per month. She lives with her&#160; husband and three children in Franklin, Tennessee.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f71e428